<template>
	<div>
		<a-modal v-show='!ishand' id='tikuan' width='50rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top: '30vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'><div v-html='"提款詳情"' style="width: 48rem;"></div></div>
			<div solt='title'>
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 48rem;" class='body_lis'>
				<div style="padding-top: 1.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='left' layout="inline" 
						hideRequiredMark >
							<a-form-model-item prop='remark' label='證券編號'>{{form.username}}</a-form-model-item>
							<a-form-model-item prop='remark' label='交易編號'>{{form.tradecode}}</a-form-model-item>
							<a-form-model-item prop='remark' label='客戶姓名'>{{form.realname}}</a-form-model-item>
							<a-form-model-item prop='remark' label='貨幣種類'>{{form.ccytype}}</a-form-model-item>
							<a-form-model-item prop='remark' label='提款金額'>{{form.price}}</a-form-model-item>
							<a-form-model-item prop='remark' label='備註信息'>{{form.remark}}</a-form-model-item>
							<!-- <div id='whand'>
							<a-form-model-item prop='remark' label='電子郵箱' style='width: 100%;'>{{record.email}}</a-form-model-item></div> -->
					</a-form-model>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['record'],
		data() {
			return {
				ishand: false,
				visible: true,
				form: {},
			}
		},
		mounted(){
			this.getdate()
		},
		methods: {
			getdate(){
				this.$ajax({
					method:'post',
					url:this.$api.TradeDetail,
					data:{
					 "aduitid":this.record.aduitid
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.form = res.data
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#tikuan{
		#whand{
			.ant-form-item-label {
				width: 15% ;
			}
		}
	}
	#tikuan .ant-modal-header,
	#tikuan .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#tikuan {
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}
		.ant-form-item-label {
			width: 16%;
		}
		.ant-form-item{
			width: 50%;
		}
		.ant-form-item label {
			font-size: .8rem !important;
		}
		.ant-form-item-children{
			font-size: .8rem !important;
		}
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
